import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-login-data',
  templateUrl: './login-data.component.html',
  styleUrls: ['./login-data.component.scss']
})
export class LoginDataComponent implements OnInit {


  private _business: BasicRegister;
  public _loading: boolean = false;
  public formAddUser: UntypedFormGroup;
  private _userBusiness: BusinessUser;
  public items: BusinessUser[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private api: MgService,
  ) { }

  ngOnInit(): void {
    this.formAddUser = this.fb.group({
      id: [null],
      business_id: [null, [Validators.required]],
      name: [undefined, [Validators.required]],
      email: [undefined, [Validators.required, Validators.email]],
      mobile: [undefined]//, [Validators.pattern("[0-9]{11}")]]
    })
  }

  public onSubmit() {
    this._loading = true;
    this.formAddUser.controls.business_id.setValue(this._business.id);
    this.api.createBusinessUser(this.formAddUser.value);
  }

}
